import { roles } from '../config/constants';
import checkUserRole from './checkUserRole';

const isBaOrRsm = (() => checkUserRole(roles.RSM, roles.BA))();

export default isBaOrRsm;
